var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressLineFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165,
    height: 32,
    viewBox: "0 0 165 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 164.5,
    height: 2,
    fill: "#2180E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressLineFilled);
export default __webpack_public_path__ + "static/media/progressLineFilled.ef2380a21d2771170d90caade31c9a11.svg";
export { ForwardRef as ReactComponent };